var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlackMic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mic",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M3.6,6.5a.613.613,0,0,1,.6.625v1.25a4.9,4.9,0,0,0,4.8,5,4.9,4.9,0,0,0,4.8-5V7.125a.6.6,0,1,1,1.2,0v1.25a6.16,6.16,0,0,1-5.4,6.219v2.531h3.6a.626.626,0,0,1,0,1.25H4.8a.626.626,0,0,1,0-1.25H8.4V14.594A6.16,6.16,0,0,1,3,8.375V7.125A.613.613,0,0,1,3.6,6.5Z",
    transform: "translate(-3 1.625)",
    fill: "#0c3148",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M11,10V3.75a2.452,2.452,0,0,0-2.4-2.5,2.452,2.452,0,0,0-2.4,2.5V10a2.452,2.452,0,0,0,2.4,2.5A2.452,2.452,0,0,0,11,10ZM8.6,0A3.677,3.677,0,0,0,5,3.75V10a3.677,3.677,0,0,0,3.6,3.75A3.677,3.677,0,0,0,12.2,10V3.75A3.677,3.677,0,0,0,8.6,0Z",
    transform: "translate(-2.6 0)",
    fill: "#0c3148",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlackMic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Black_mic.50c9d534aeddf874c349cd233a348f3f.svg";